export default __webpack_public_path__ + "static/media/doggles.414585ca.png";